import React, { useState, useEffect } from "react";
import { NAIL_IMAGES } from "../mock/mock";
import { listGallery, mediaSrc } from "../lib/api";
import { X } from "lucide-react";

export default function Portfolio() {
  const [active, setActive] = useState(null);
  const [images, setImages] = useState(NAIL_IMAGES);
  const [count, setCount] = useState(12);

  useEffect(() => {
    listGallery()
      .then((items) => {
        if (items && items.length) setImages(items.map((it) => mediaSrc(it.src)));
      })
      .catch((e) => {
        if (process.env.NODE_ENV !== "production") console.error("Gallery load failed:", e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shown = images.slice(0, count);

  return (
    <section id="portfolio" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-14">
          <p className="section-line text-gold mb-4">Our Portfolio</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Our most requested <span className="gold-gradient-text italic">looks.</span>
          </h2>
          <p className="mt-4 text-cream/60">A glimpse into the designs & trends crafted at VIIMII STUDIO.</p>
        </div>

        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
          {shown.map((img, i) => (
            <button
              key={`${img}-${i}`}
              onClick={() => setActive(img)}
              className="reveal group relative mb-4 block w-full overflow-hidden rounded-2xl border hairline"
            >
              <img
                src={img}
                alt={`Nail art ${i + 1}`}
                className="w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" />
            </button>
          ))}
        </div>

        {count < images.length && (
          <div className="text-center mt-12">
            <button
              onClick={() => setCount(images.length)}
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border hairline text-cream/85 hover:text-gold transition-colors"
            >
              View More Work →
            </button>
          </div>
        )}
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm grid place-items-center p-4"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setActive(null)}>
            <X size={32} />
          </button>
          <img src={active} alt="Preview" className="max-h-[85vh] max-w-[92vw] rounded-2xl object-contain" />
        </div>
      )}
    </section>
  );
}
